export default "__VITE_ASSET__B6URKY2W__"